import type {ErrorResponse, RequestOptions} from '@/types/api';

const API_BASE =
	typeof process !== 'undefined' && process.env?.REACT_APP_API_URL !== undefined
		? process.env.REACT_APP_API_URL
		: '';

export type {ErrorResponse, RequestOptions};

export async function request<T>(
	path: string,
	options: RequestOptions = {}
): Promise<{data?: T; error?: ErrorResponse; status: number}> {
	const {body, ...rest} = options;
	const fetchBody: BodyInit | null | undefined =
		body !== undefined ? JSON.stringify(body) : undefined;
	const res = await fetch(`${API_BASE}${path}`, {
		...rest,
		headers: {
			'Content-Type': 'application/json',
			...options.headers,
		},
		credentials: 'include',
		body: fetchBody,
	});
	const text = await res.text();
	let data: T | undefined;
	let error: ErrorResponse | undefined;
	if (text) {
		try {
			const json = JSON.parse(text);
			if (res.ok) data = json as T;
			else error = json as ErrorResponse;
		} catch {
			if (!res.ok) error = {message: res.statusText || 'Request failed'};
		}
	}
	if (!res.ok && !error) error = {message: res.statusText || 'Request failed'};
	return {data, error, status: res.status};
}
